/**
 * We define in units of em (same as Chakra). rem and em behave the same when
 * applied to the root font size on the html element.
 */
export enum SCREEN_SIZE {
  /**
   * @deprecated
   */
  XXS = "20em", // note: it should be possible to remove this one now
  XS = "20em",
  SM = "30em",
  MD = "48em",
  LG = "62em",
  XL = "80em",
  XXL = "96em",
}

/**
 * breakpoints are based on the available viewport width.
 * i.e. the browser window, not the actual device screen size.
 */
export const breakpoints = {
  // base = 0px and up, always exists in the theme
  "2xs": SCREEN_SIZE.XXS, // deprecated, don't use it
  xs: SCREEN_SIZE.XS, // 320px and up - smallest mobile widths
  sm: SCREEN_SIZE.SM, // 480px and up - larges mobile widths
  md: SCREEN_SIZE.MD, // 768px and up - tablet widths
  lg: SCREEN_SIZE.LG, // 992px and up - pc
  xl: SCREEN_SIZE.XL, // 1280px and up - large pc
  "2xl": SCREEN_SIZE.XXL, // 1536px and up - very large px,
} as const;
